import React from 'react';
import { StyledRangeInput } from './RangeSlider.styles.mjs';

const RangeSlider = (props) => {
    const { max, value } = props;
    let progress = 0;
    if (max && value) {
        progress = (+value / +max) * 100;
    }
    return React.createElement(StyledRangeInput, Object.assign({}, props, { type: "range", progress: progress }));
};

export { RangeSlider as default };
//# sourceMappingURL=RangeSlider.mjs.map
